<template>
  <div>
    <div class="topTitle ">
      <div v-if="$route.query.type1 === 'Gameproblem'">
        <span @click="gobackproblem" style="cursor: pointer;">返回问题</span> /
        {{ $route.query.code + "\xa0" + $route.query.title }}
      </div>
      <div v-if="$route.query.type1 === 'tuanduitidan'">
        <span @click="goback1" style="cursor: pointer;">返回问题</span> /
        {{ $route.query.code + "\xa0" + $route.query.title }}
      </div>
      <div v-if="$route.query.type1 === 'tidan'">
        <span @click="goback2" style="cursor: pointer;">返回问题</span> /
        {{ $route.query.code + "\xa0" + $route.query.title }}
      </div>
      <div v-if="$route.query.type1 === 'tuandui'">
        <span @click="goback3" style="cursor: pointer;">返回问题</span> /
        {{ $route.query.code + "\xa0" + $route.query.title }}
      </div>
      <div v-if="$route.query.type1 === 'tuanduiStu'">
        <span @click="goback4" style="cursor: pointer;">返回问题</span> /
        {{ $route.query.code + "\xa0" + $route.query.title }}
      </div>
      <div v-if="$route.query.type1 === 'game'">
        <span @click="goback5" style="cursor: pointer;">返回问题</span> /
        {{ $route.query.code + "\xa0" + $route.query.title }}
      </div>
      <div v-if="$route.query.type1 === 'recordOJ'">
        <span @click="goback6" style="cursor: pointer;">返回问题</span> /
        {{ $route.query.code + "\xa0" + $route.query.title }}
      </div>
      <div
        v-if="
          $route.query.type1 != 'tidan' &&
            $route.query.type1 != 'tuanduitidan' &&
            $route.query.type1 != 'tuandui' &&
            $route.query.type1 != 'tuanduiStu' &&
            $route.query.type1 != 'game' &&
            $route.query.type1 != 'recordOJ' &&
            $route.query.type1 != 'Gameproblem'
        "
      >
        <el-page-header @back="goback">
          <template #content>
            <span style="color:#303133;">
              题目解析
            </span>
          </template>
        </el-page-header>
      </div>
    </div>
    <div class="TopicAnalysis">
      <el-row :gutter="10">
        <el-col :span="8">
          <div class="bg">
            <div class="clearfix" style="width:100%">
              <div class="fl" style="width:40%">
                <el-input
                  @submit.native.prevent
                  v-model="title"
                  clearable=""
                  placeholder="请输入标题"
                  size="mini"
                  @keyup.enter.native="search"
                ></el-input>
              </div>
              <div
                class="fl"
                style="margin-left:10px"
                v-if="$store.state.user.identity === 1"
              >
                <el-button @click="write" size="mini" type="primary"
                  >写题解</el-button
                >
              </div>
              <div
                class="fr"
                style="margin-top:5px"
                v-if="$store.state.user.identity === 1"
              >
                <el-checkbox v-model="checked">我的题解</el-checkbox>
              </div>
            </div>
            <!-- <div>
              <div style="margin-top:20px" v-if="$store.state.user.identity === 1">
                <el-checkbox v-model="checked">我的题解</el-checkbox>
              </div>
            </div> -->
            <div style="margin-top:20px">
              <el-radio v-model="radio" label="all">全部</el-radio>
              <el-radio v-model="radio" label="0">C</el-radio>
              <el-radio v-model="radio" label="1">C++</el-radio>
              <el-radio v-model="radio" label="2">Python3</el-radio>
            </div>
            <div
              style="margin-top:20px;width: 100%; "
              :class="[isShow1 == true ? 'showBox' : 'showBox1']"
              class="clearfix"
            >
              <div style="width:80px;height: 100%;" class="fl">
                <el-checkbox
                  v-model="CheckAll"
                  :indeterminate="isIndeterminate"
                  @change="handleCheckAllChange"
                  >全选</el-checkbox
                >
              </div>
              <div style="width:calc(100% - 110px)" class="fl">
                <el-checkbox-group
                  v-model="checkedCities"
                  @change="handleCheckedCitiesChange"
                  style="width:100%"
                >
                  <el-checkbox
                    v-for="(item, index) in KnowledgeList"
                    :label="item"
                    :key="index"
                    style="margin-bottom: 10px;"
                  >
                    <div>{{ item.title }}</div>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="fr">
                <span
                  v-if="isShow1"
                  style="cursor: pointer; color:#409eff"
                  @click="show"
                  >展开</span
                >
                <span
                  v-if="isShow"
                  style="cursor: pointer; color:#409eff"
                  @click="show1"
                  >收起</span
                >
              </div>
            </div>
            <div style="margin-top:20px">
              <el-divider></el-divider>
            </div>
            <!-- 题解列表 -->
            <div v-if="this.tableData.length === 0 ? true : false">
              <el-empty description="暂无题解"></el-empty>
              <!-- 暂无解析 -->
            </div>
            <div class="ExplanationList">
              <ul>
                <li
                  v-for="(item, index) in tableData"
                  :key="index"
                  :attr-name="item.id + ''"
                  @click="checkList(item, index)"
                >
                  <div class="clearfix">
                    <div class="fl" v-if="item.user_id != null">
                      <el-image
                        style="width: 30px; height: 30px;margin-top:-5px;border-radius: 5px;"
                        :src="item.headImg"
                        fit="cover"
                      ></el-image>
                    </div>
                    <div class="fl" v-if="item.user_id === null">
                      <el-image
                        style="width: 30px; height: 30px;margin-top:-5px"
                        src="https://wugecdn.steam.fun/resources/static/images/logo.png"
                        fit="cover"
                      ></el-image>
                    </div>
                    <div class="fl txt1" :class="{ active1: active === index }">
                      {{ item.title }}
                    </div>
                    <div class="fl">
                      <el-tag
                        size="mini"
                        type=""
                        effect="dark"
                        v-if="item.sort_type === 1"
                        >官方</el-tag
                      >
                      <el-tag
                        size="mini"
                        type="success"
                        effect="dark"
                        v-if="item.sort_type === 2"
                        >精选</el-tag
                      >
                      <!-- <el-tag size="mini" type="warning" effect="dark" v-if="item.sort_type === 3">普通</el-tag> -->
                    </div>

                    <div
                      v-if="isShow2"
                      class="fr"
                      style="margin-left: 20px;color:#F56C6C"
                      @click.stop="del(item)"
                    >
                      删除
                    </div>
                    <div
                      v-if="isShow2"
                      class="fr"
                      style="color:#409EFF"
                      @click.stop="edit(item, index)"
                    >
                      编辑
                    </div>
                  </div>
                  <div
                    style="color:#606266"
                    class="limit"
                    v-html="item.title_str"
                  ></div>
                </li>
              </ul>
              <div style="margin: 20px 20px 20px 20px; text-align: right">
                <el-pagination
                  @current-change="handleCurrent"
                  :current-page="page_no"
                  :page-size="page_size"
                  layout="total, prev, pager, next, jumper"
                  :total="total"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="bg" v-if="isShow5">
            <el-empty description="暂无题解"></el-empty>
          </div>
          <div v-if="isShow7">
            <div class="bg" v-if="isShow3">
              <el-form ref="form" :model="form" size="small" label-width="80px">
                <el-form-item label="题解标题" required>
                  <el-input
                    v-model="form.title"
                    clearable
                    placeholder="请输入标题"
                  ></el-input>
                </el-form-item>
              </el-form>
              <el-form
                ref="form"
                :model="form"
                size="mini"
                :inline="true"
                label-width="80px"
              >
                <el-form-item label="算法标签">
                  <el-select
                    class="difficulty-select"
                    @change="$forceUpdate()"
                    v-model="form.tagIds"
                    collapse-tags
                    multiple
                    filterable
                    style="width:160px"
                  >
                    <el-option-group
                      v-for="group in allData"
                      :key="group.id"
                      :label="group.title"
                    >
                      <el-option
                        v-for="item in group.tagArrInfo"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id"
                      >
                      </el-option>
                    </el-option-group>
                  </el-select>
                </el-form-item>
                <el-form-item label="编程语言">
                  <el-select
                    v-model="form.languages"
                    multiple
                    collapse-tags
                    placeholder="请选择编程语言"
                    clearable
                    style="width:160px"
                  >
                    <el-option
                      v-for="item in languagess"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="类型">
                <el-select v-model="form.sort_type" placeholder="请选择类型" clearable style="width:160px">
                  <el-option v-for="item in sortType" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item> -->
              </el-form>
              <!-- <Tinymce
                v-if="isShow7"
                v-model="form.content"
                style="width:100%"
                ></Tinymce> -->
              <div class="md-box">
                <markdownShow
                  v-if="isShow7"
                  @changeMardown="changeMardown"
                  :markdown.sync="form.content"
                  @SaveMarkDown="SaveMarkDown"
                ></markdownShow>
              </div>
              <div class="fr" style="margin-top:10px">
                <el-button type="primary" size="small" @click="submit('form')"
                  >保存题解</el-button
                >
              </div>
            </div>
            <div class="bg1" v-if="isShow4">
              <div class="txt">
                {{ content.title }}
              </div>
              <div class="clearfix" style="margin-top:10px">
                <div class="fl">
                  <div v-if="content.user_id === null">
                    <div class="clearfix">
                      <div class="fl">
                        <el-image
                          style="width: 30px; height: 30px;margin-top:5px;"
                          src="https://wugecdn.steam.fun/resources/static/images/logo.png"
                          fit="cover"
                        ></el-image>
                      </div>
                      <div
                        class="fl"
                        style="line-height: 40px;margin-left:10px"
                      >
                        格小C
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="clearfix">
                      <div class="fl">
                        <el-image
                          style="width: 30px; height: 30px;margin-top:5px;border-radius: 5px;"
                          :src="content.headImg"
                          fit="cover"
                        ></el-image>
                      </div>
                      <div
                        class="fl"
                        style="line-height: 40px;margin-left:10px;"
                      >
                        {{ content.realname }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="fl" style="margin-left: 10px;line-height: 40px">
                  发布于:{{ content.update_time }}
                </div>
              </div>
              <div class="clearfix">
                <div class="fl" style="line-height: 40px">
                  <el-tag
                    size="mini"
                    type=""
                    effect="dark"
                    v-if="content.sort_type === 1"
                    >官方</el-tag
                  >
                  <el-tag
                    size="mini"
                    type="success"
                    effect="dark"
                    v-if="content.sort_type === 2"
                    >精选</el-tag
                  >
                  <!-- <el-tag size="mini" type="warning" effect="dark" v-if="content.sort_type === 3">普通</el-tag> -->
                </div>
                <div class="fl" style="line-height: 40px">
                  <span v-for="item in content.problemTagArr" :key="item.id">
                    <el-tag
                      type="info"
                      size="mini"
                      style="margin-left: 10px;"
                      >{{ item.tagInfo.title }}</el-tag
                    >
                  </span>
                </div>
                <div class=" fl" style="line-height: 40px">
                  <span v-for="item in content.languages" :key="item.id">
                    <el-tag
                      type="info"
                      size="mini"
                      style="margin-left: 10px;"
                      v-if="item === '0'"
                      >C</el-tag
                    >
                    <el-tag
                      type="info"
                      size="mini"
                      style="margin-left: 10px;"
                      v-if="item === '1'"
                      >C++</el-tag
                    >
                    <el-tag
                      type="info"
                      size="mini"
                      style="margin-left: 10px;"
                      v-if="item === '2'"
                      >Python3</el-tag
                    >
                  </span>
                </div>
              </div>
              <el-divider></el-divider>
              <div class="main_cotton">
                <!-- 解析视频 -->
                <div class="video-box" v-if="content.video_url_arr">
                  <div
                    class="title"
                    v-if="JSON.parse(content.video_url_arr).length > 0"
                  >
                    <svg
                      t="1724310100931"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="3404"
                      width="28"
                      height="28"
                    >
                      <path
                        d="M849.170732 0c97.404878 0 174.829268 77.42439 174.829268 174.829268v674.341464c0 97.404878-77.42439 174.829268-174.829268 174.829268H174.829268c-97.404878 0-174.829268-77.42439-174.829268-174.829268V174.829268c0-97.404878 77.42439-174.829268 174.829268-174.829268h674.341464z m-239.765854 299.707317H252.253659c-27.473171 0-49.95122 19.980488-52.448781 47.453659V691.82439c0 27.473171 19.980488 49.95122 47.453659 52.448781h362.146341c27.473171 0 49.95122-19.980488 52.448781-47.453659v-27.473171L699.317073 699.317073c14.985366 12.487805 37.463415 14.985366 54.946342 4.995122 17.482927-7.492683 27.473171-24.97561 27.47317-42.458536v-274.731708c0-19.980488-9.990244-37.463415-29.970731-44.956097-17.482927-7.492683-34.965854-7.492683-49.95122 2.497561l-2.497561 2.497561-39.960975 29.970731V349.658537c0-27.473171-19.980488-49.95122-47.453659-52.448781l-2.497561 2.497561z m-244.760976 137.365854c4.995122-2.497561 9.990244-2.497561 14.985366 0l2.497561 2.497561 104.897561 69.931707c4.995122 2.497561 7.492683 7.492683 7.492683 14.985366 0 4.995122-2.497561 9.990244-4.995122 12.487805l-2.497561 2.497561-107.395122 72.429268c-4.995122 2.497561-12.487805 4.995122-17.482927 0-4.995122-2.497561-7.492683-7.492683-9.990243-12.487805v-144.858536c2.497561-9.990244 7.492683-14.985366 12.487804-17.482927z"
                        fill="#2488ef"
                        p-id="3405"
                      ></path>
                    </svg>
                    <span>视频解析</span>
                  </div>
                  <div
                    class="content"
                    v-if="JSON.parse(content.video_url_arr).length > 0"
                  >
                    <div
                      style="margin-top:20px;"
                      v-for="(videoItemUrl, videoIndex) in JSON.parse(
                        content.video_url_arr
                      )"
                      :key="videoIndex"
                    >
                      <video
                        :src="videoItemUrl"
                        controls="controls"
                        controlslist="nodownload"
                      ></video>
                    </div>
                  </div>
                </div>
                <!-- <div style="margin-top:10px" v-html="content.content"></div> -->

                <div v-if="content.video_url_arr">
                  <el-divider
                    v-if="JSON.parse(content.video_url_arr).length > 0"
                  ></el-divider>
                </div>

                <mavon-editor
                  :style="{ 'min-height': '0px' }"
                  preview-background="transparent"
                  v-model="content.content"
                  defaultOpen="preview"
                  :boxShadow="false"
                  :editable="false"
                  :subfield="false"
                  :toolbarsFlag="false"
                ></mavon-editor>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  getOjProblemTagGroupList,
  tchAddOrUpdateOjProblemAnalysis,
  tchGetOjProblemAnalysisList,
  tchDeleteOjProblemAnalysis,
} from "@/api/educational.js";
// import Tinymce from '@/components/Tinymce'
import markdownShow from "@/components/markdownShow";
export default {
  components: {
    // Tinymce,
    markdownShow,
  },
  data() {
    return {
      isShow7: true,
      briefIntroduction: "",
      isIndeterminate: true,
      num: "",
      KnowledgeList: [],
      checkedCities: [],
      difficultyId: "",
      tagArr: [],
      isOwn: 0,
      active: 0,
      content: {},
      isShow5: false,

      isShow3: false,
      isShow4: true,

      form: {
        title_str: "",
        title: "",
        tagIds: [],
        languages: [],
        content: "",
      },
      page_no: 1,
      page_size: 10,
      total: 20,
      isShow2: false,
      isShow1: true,
      isShow: false,
      radio: "all",
      checked: false,
      title: "",
      allData: [],
      CheckAll: false,
      checkAll: false,
      cities: [], //数据源
      checkedArr: [], // 分组全选选中情况
      checkedBtn: [], // 所有小选的选中情况
      tableData: [],
      languagess: [
        {
          id: "0",
          name: "C",
        },
        {
          id: "1",
          name: "C++",
        },
        {
          id: "2",
          name: "Python3",
        },
      ],
      sortType: [
        {
          id: 1,
          name: "官方",
        },
        {
          id: 2,
          name: "精选",
        },
        {
          id: 3,
          name: "普通",
        },
      ],
    };
  },
  watch: {
    checked(val) {
      console.log(val, 125487);
      if (val === false) {
        this.isOwn = 0;
        this.search();
        this.isShow2 = val;
      } else {
        this.isOwn = 1;
        this.search();
        this.isShow2 = val;
        console.log(this.tableData);
        //  this.content = this.tableData[0]
      }
    },
    radio(val) {
      console.log(val);
      this.radio = val;
      this.search();
    },
  },
  created() {},
  mounted() {
    console.log(this.$route.query.type, 5632323);

    this.getOjProblemTagGroupList();
    this.tchGetOjProblemAnalysisList();
  },
  methods: {
    delHtmlTag(str) {
      var re1 = new RegExp("<.+?>", "g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = str.replace(re1, ""); //执行替换成空字符
      return msg;
    },
    gobackproblem() {
      this.$router.push({
        name: "questionBankDetails",
        query: {
          oj_problem_id: this.$route.query.oj_problem_id,
          code: this.$route.query.code,
          title: this.$route.query.title,
          id: this.$route.query.id,
          language: this.$route.query.language,
          pageON: this.$route.query.pageON,
          pageSize: this.$route.query.pageSize,
          type1: "Gameproblem",
          gameId: this.$route.query.gameId,
          teamProblemlistRelationId: this.$route.query
            .teamProblemlistRelationId,
        },
      });
    },
    goback1() {
      this.$router.push({
        name: "questionBankDetails",
        query: {
          id: this.$route.query.id,
          totalSubmissionNum: this.$route.query.totalSubmissionNum,
          acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
          contest_id: this.$route.query.contest_id,
          type1: "tuanduitidan",
          language: this.$route.query.language,
          txt: this.$route.query.txt,
          type: this.$route.query.type,
          oj_problem_id: this.$route.query.oj_problem_id,
          code: this.$route.code,
          title: this.$route.title,
          page_notd: this.$route.query.page_notd,
          page_sizetd: this.$route.query.page_sizetd,
          problemlist_id: this.$route.query.problemlist_id,
          practice: this.$route.query.practice,
          problemAcceptNum: this.$route.query.problemAcceptNum,
          problem_num: this.$route.query.problem_num,
          team: this.$route.query.team,
          ProblemLength: this.$route.query.ProblemLength,
          page_no: this.$route.query.page_no,
          page_size: this.$route.query.page_size,
          TableIndex: this.$route.query.TableIndex,
          teamProblemlistRelationId: this.$route.query
            .teamProblemlistRelationId,
        },
      });
    },
    goback2() {
      this.$router.push({
        name: "questionBankDetails",
        query: {
          description: this.$route.query.description,
          id: this.$route.query.id,
          totalSubmissionNum: this.$route.query.totalSubmissionNum,
          acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
          contest_id: this.$route.query.contest_id,
          type1: "tidan",
          // practice: 'practice',
          language: this.$route.query.language,
          txt: this.$route.query.txt,
          type: this.$route.query.type,
          oj_problem_id: this.$route.query.oj_problem_id,
          code: this.$route.code,
          title: this.$route.title,
          page_notd: this.$route.query.page_notd,
          page_sizetd: this.$route.query.page_sizetd,
          problemlist_id: this.$route.query.problemlist_id,
          practice: this.$route.query.practice,
          problemAcceptNum: this.$route.query.problemAcceptNum,
          problem_num: this.$route.query.problem_num,
          teamProblemlistRelationId: this.$route.query
            .teamProblemlistRelationId,
        },
      });
    },
    goback3() {
      this.$router.push({
        name: "questionBankDetails",
        query: {
          id: this.$route.query.id,
          totalSubmissionNum: this.$route.query.totalSubmissionNum,
          acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
          contest_id: this.$route.query.contest_id,
          type1: "tuandui",
          // practice: 'practice',
          language: this.$route.query.language,
          txt: this.$route.query.txt,
          type: this.$route.query.type,
          oj_problem_id: this.$route.query.oj_problem_id,
          code: this.$route.code,
          title: this.$route.title,
          page_notd: this.$route.query.page_notd,
          page_sizetd: this.$route.query.page_sizetd,
          problemlist_id: this.$route.query.problemlist_id,
          practice: this.$route.query.practice,
          problemAcceptNum: this.$route.query.problemAcceptNum,
          problem_num: this.$route.query.problem_num,

          activeName: this.activeName,
          page_no: this.page_no,
          page_size: this.page_size,
          team: this.$route.query.team,
          teamProblemlistRelationId: this.$route.query
            .teamProblemlistRelationId,
        },
      });
    },
    goback6() {
      this.$router.push({
        name: "questionBankDetails",
        query: {
          id: this.$route.query.id,
          type1: "recordOJ",
          languages: this.$route.query.languages,
          teamProblemlistRelationId: this.$route.query
            .teamProblemlistRelationId,
        },
      });
    },
    goback5() {
      this.$router.push({
        name: "questionBankDetails",
        query: {
          activeName: "second",
          id: this.$route.query.id,
          oj_contest_id: this.$route.query.oj_contest_id,
          isShow: this.$route.query.isShow,
          title: this.$route.query.title,
          type1: "game1",
          languages: this.$route.query.languages,
          end_date: this.$route.query.end_date,
          rule_type: this.$route.query.rule_type,
          typetime: this.$route.query.typetime,
          teamProblemlistRelationId: this.$route.query
            .teamProblemlistRelationId,
        },
      });
    },
    goback4() {
      this.$router.push({
        name: "questionBankDetails",
        query: {
          id: this.$route.query.id,
          totalSubmissionNum: this.$route.query.totalSubmissionNum,
          acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
          contest_id: this.$route.query.contest_id,
          type1: "tuanduiStu",
          // practice: 'practice',
          language: this.$route.query.language,
          txt: this.$route.query.txt,
          type: this.$route.query.type,
          oj_problem_id: this.$route.query.oj_problem_id,
          code: this.$route.code,
          title: this.$route.title,
          page_notd: this.$route.query.page_notd,
          page_sizetd: this.$route.query.page_sizetd,
          problemlist_id: this.$route.query.problemlist_id,
          practice: this.$route.query.practice,
          problemAcceptNum: this.$route.query.problemAcceptNum,
          problem_num: this.$route.query.problem_num,

          activeName: this.activeName,
          page_no: this.page_no,
          page_size: this.page_size,
          team: this.$route.query.team,
          teamProblemlistRelationId: this.$route.query
            .teamProblemlistRelationId,
        },
      });
    },
    goback() {
      this.$router.push({
        name: "questionBankDetails",
        query: {
          id: this.$route.query.id,
          totalSubmissionNum: this.$route.query.totalSubmissionNum,
          acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
          contest_id: this.$route.query.contest_id,
          type1: "problem2",
          language: this.$route.query.language,
          txt: this.$route.query.txt,
          // id: this.$route.query.id,
          // totalSubmissionNum: this.$route.query.totalSubmissionNum,
          // acceptSubmissionNum: this.$route.query.acceptSubmissionNum,
          // contest_id: this.$route.query.contest_id,
          // type1: 'tuanduitidan',
          // language: this.$route.query.language,
          // txt: this.$route.query.txt,

          // oj_problem_id: this.$route.query.oj_problem_id,
          // code: this.$route.code,
          // title: this.$route.title,
          // page_notd: this.$route.query.page_notd,
          // page_sizetd: this.$route.query.page_sizetd,
          // problemlist_id: this.$route.query.problemlist_id,
          // practice: this.$route.query.practice,
          // problemAcceptNum: this.$route.query.problemAcceptNum,
          // problem_num: this.$route.query.problem_num,
          // team: this.$route.query.team,
          teamProblemlistRelationId: this.$route.query
            .teamProblemlistRelationId,
        },
      });
    },
    //删除
    del(row) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          tchDeleteOjProblemAnalysis({
            id: row.id,
          }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.tchGetOjProblemAnalysisList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //h获取列表
    tchGetOjProblemAnalysisList() {
      tchGetOjProblemAnalysisList({
        tagIds: this.form.tagIds,
        language: this.radio,
        title: this.title,
        problem_id: this.$route.query.oj_problem_id,
        page_no: this.page_no,
        page_size: this.page_size,
        isOwn: this.isOwn,
      }).then((res) => {
        this.tableData = res.ojProblemAnalysisList;
        this.tableData.map((item) => {
          item.title_str = this.delHtmlTag(item.content);
          console.log(item.content, 124567);
          console.log(this.tableData, 124567);
        });

        this.total = res.total;
        if (this.tableData.length === 0) {
          this.isShow5 = true;
          this.isShow4 = false;
        } else {
          this.isShow5 = false;
          this.isShow4 = true;
          this.content = this.tableData[0];
          console.log(this.content, 1245);
        }
      });
    },
    search() {
      tchGetOjProblemAnalysisList({
        tagIds: this.form.tagIds,
        language: this.radio,
        title: this.title,
        problem_id: this.$route.query.oj_problem_id,
        page_no: 1,
        page_size: this.page_size,
        isOwn: this.isOwn,
      }).then((res) => {
        this.tableData = res.ojProblemAnalysisList;
        this.tableData.map((item) => {
          item.title_str = this.delHtmlTag(item.content);
          console.log(item.content, 124567);
          console.log(this.tableData, 124567);
        });
        if (this.tableData.length === 0) {
          this.isShow5 = true;
          this.isShow4 = false;
        } else {
          this.isShow5 = false;
          this.isShow4 = true;
          this.content = this.tableData[0];
        }
        this.total = res.total;
      });
    },
    //编辑
    edit(row, index) {
      this.isShow7 = false;
      this.$nextTick(() => {
        this.isShow7 = true;
      });
      this.active = index;
      this.num = index;
      console.log(row);
      console.log(this.num);

      this.isShow3 = true;
      this.isShow4 = false;
      this.difficultyId = row.id;
      this.form.tagIds = [];
      this.form.title = row.title;
      this.form.languages = JSON.parse(row.languages);
      this.form.content = row.content;
      row.problemTagArr.map((item) => {
        console.log(item.tagInfo, 1234);
        this.form.tagIds.push(item.tagInfo.id);
        console.log(this.form.tagIds, 1234);
      });
    },
    checkList(item, index) {
      this.isShow7 = false;
      this.$nextTick(() => {
        this.isShow7 = true;
      });
      console.log(item, 114);
      this.active = index;
      this.content = item;
      console.log("content");
      console.log(this.content);

      this.num = index;
      console.log(item);
      console.log(this.num);

      this.isShow3 = false;
      this.isShow4 = true;
      this.difficultyId = item.id;
      this.form.tagIds = [];
      this.form.title = item.title;
      this.form.languages = JSON.parse(item.languages);
      this.form.content = item.content;
      item.problemTagArr.map((item) => {
        console.log(item.tagInfo, 1234);
        this.form.tagIds.push(item.tagInfo.id);
        console.log(this.form.tagIds, 1234);
      });
    },
    write() {
      this.isShow3 = true;
      this.isShow4 = false;
      this.isShow5 = false;
      this.form.title = "";
      this.form.tagIds = [];
      this.form.languages = [];
      this.form.content = "";
      this.difficultyId = "";
    },
    submit(formName) {
      // checked
      if (!this.form.title) {
        return this.$message.warning("请输入题解标题");
      } else if (!this.form.content) {
        return this.$message.warning("请输入题解内容");
      }
      this.checked = false;
      console.log(this.checked, 123465);
      this.isShow3 = false;
      this.isShow4 = true;
      this.form.languages = JSON.stringify(this.form.languages);
      this.form.tagIds = JSON.stringify(this.form.tagIds);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.difficultyId) {
            console.log(123, 45);
            tchAddOrUpdateOjProblemAnalysis({
              show_type: 2, // 1:html 2:md
              id: this.difficultyId,
              oj_problem_id: this.$route.query.oj_problem_id,
              ...this.form,
            }).then(() => {
              this.$message.success("修改成功!");
              this.active = this.num;
              tchGetOjProblemAnalysisList({
                // tagIds: this.form.tagIds,
                language: this.radio,
                title: this.title,
                problem_id: this.$route.query.oj_problem_id,
                page_no: 1,
                page_size: this.page_size,
                isOwn: 0,
              }).then((res) => {
                this.tableData = res.ojProblemAnalysisList;
                this.tableData.map((item) => {
                  item.title_str = this.delHtmlTag(item.content);
                });
                if (this.tableData.length === 0) {
                  this.isShow5 = true;
                  this.isShow4 = false;
                } else {
                  this.isShow5 = false;
                  this.isShow4 = true;
                  this.content = this.tableData[0];
                }
                this.total = res.total;
              });
            });
          } else {
            tchAddOrUpdateOjProblemAnalysis({
              show_type: 2, // 1:html 2:md
              oj_problem_id: this.$route.query.oj_problem_id,
              ...this.form,
            }).then(() => {
              this.$message.success("添加成功!");
              tchGetOjProblemAnalysisList({
                // tagIds: this.form.tagIds,
                language: this.radio,
                title: this.title,
                problem_id: this.$route.query.oj_problem_id,
                page_no: 1,
                page_size: this.page_size,
                isOwn: 0,
              }).then((res) => {
                this.tableData = [];
                this.tableData = res.ojProblemAnalysisList;
                console.log(this.tableData, 13213456);
                this.tableData.map((item) => {
                  item.title_str = this.delHtmlTag(item.content);
                });
                if (this.tableData.length === 0) {
                  this.isShow5 = true;
                  this.isShow4 = false;
                } else {
                  this.isShow5 = false;
                  this.isShow4 = true;
                  this.content = this.tableData[0];
                }
                this.total = res.total;
              });
            });
          }
        }
      });
    },

    handleCurrent(val) {
      this.page_no = val;
      this.tchGetOjProblemAnalysisList();
    },
    show() {
      this.isShow1 = false;
      this.isShow = true;
    },
    show1() {
      this.isShow1 = true;
      this.isShow = false;
    },
    getOjProblemTagGroupList() {
      getOjProblemTagGroupList({}).then((res) => {
        this.allData = res.ojProblemTagGroupList;
        console.log("知识点数据");
        console.log(res);
        console.log(this.allData);
        this.KnowledgeList = [];
        this.allData.map((item) => {
          item.tagArrInfo.map((item1) => {
            this.KnowledgeList.push(item1);
          });
        });
      });
    },
    handleCheckAllChange(val) {
      let ids = [];
      this.form.tagIds = [];
      console.log(val, 11584);

      this.checkedCities = val ? this.KnowledgeList : [];
      this.isIndeterminate = false;
      if (val === true) {
        this.KnowledgeList.map((item) => {
          ids.push(item.id);
        });
        this.form.tagIds = JSON.stringify(ids);
        this.search();
      } else {
        this.search();
      }
    },
    handleCheckedCitiesChange(value) {
      this.KnowledgeList.map((item2, index) => {
        value.map((item3) => {
          if (item2.id === item3.id) {
            console.log(123);
            this.KnowledgeList.splice(index, 1);
            this.KnowledgeList.unshift(item3);
          }
        });
      });

      let checkedCount = value.length;
      this.checkAll = checkedCount === this.KnowledgeList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.KnowledgeList.length;
      let ids = [];
      value.map((item) => {
        console.log(item.id);
        ids.push(item.id);
      });
      this.form.tagIds = JSON.stringify(ids);
      this.search();
    },
    changeMardown(val) {
      console.log(val);
      this.form.content = val;
    },
    SaveMarkDown(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);
      this.form.content = md;
    },
  },
};
</script>
<style></style>

<style scoped lang="scss">
.TopicAnalysis {
  margin: 10px;
  min-height: calc(100vh - 210px);
  box-sizing: border-box;
}

.TopicAnalysis ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background: #f1f1f1;
  /*可以设置轨道颜色*/
  padding-right: 2px;
}

/*滚动条*/
.TopicAnalysis ::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

// .TopicAnalysis ::-webkit-scrollbar {
//   display: none; /* Chrome Safari */
//   -ms-overflow-style: none; /* IE 10+ */
// }
/*滚动条样式*/

.bg {
  height: calc(100vh - 150px);
  // min-height: 100vh;
  background: #fff;
  padding: 20px;
  overflow: hidden;
}

.bg1 {
  height: calc(100vh - 150px);
  // min-height: 100vh;
  background: #fff;
  padding: 20px;
  overflow-y: scroll;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.top {
  font-size: 18px;
  font-weight: 300;
}

::v-deep .el-divider--horizontal {
  margin-top: 0px;
  background: #f0f3f9;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.showBox {
  height: 24px;
  overflow: hidden;
}

.showBox1 {
  height: 100%;
  overflow: auto;
}

.txt {
  font-size: 16px;
  font-weight: bold;
}

.active1 {
  color: #409eff;
}

.ExplanationList {
  height: calc(100vh - 317px);
  overflow-y: auto;
}

.ExplanationList li {
  // height: 150px;

  border-bottom: 1px solid #f0f3f9;
  margin-top: 10px;
  padding: 10px 0;
  cursor: pointer;
}

.txt1 {
  font-size: 16px;
  font-weight: bold;
  margin: 0 15px;
}

::v-deep .mce-container {
  overflow: auto;
}

.limit {
  overflow: hidden;
  text-overflow: ellipsis;
  /* 超出部分省略号 */
  word-break: break-all;
  /* break-all(允许在单词内换行。) */
  display: -webkit-box;
  /* 对象作为伸缩盒子模型显示 */
  -webkit-box-orient: vertical;
  /* 设置或检索伸缩盒对象的子元素的排列方式 */
  -webkit-line-clamp: 2;
  /* 显示的行数 */
  line-height: 24px;
}

::v-deep .el-divider--horizontal {
  margin: 0;
}

/deep/ .main_cotton {
  img {
    max-width: 100%;
  }
  .video-box {
    width: 100%;
    padding: 20px 0;
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      span {
        padding-left: 10px;
        font-size: 14px;
        font-weight: bold;
        color: #409eff;
      }
    }
    .content {
      video {
        width: 100%;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

/deep/ .v-note-wrapper {
  border: 0px;
  background-color: transparent;
}

/deep/ .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  padding: 0;
}
/deep/.markdown-body code {
  font-size: 18px;
}
/deep/.markdown-body .hljs {
  color: #24292e;
  background: #f6f8fa;
}
</style>
